import React, { useState, useEffect } from 'react'
import {
  Container,
  Nav,
  Navbar,
  Col,
  Row,
  Button,
  Form,
  FormControl,
  InputGroup,
  Modal,
  DropdownButton,
  Dropdown
} from "react-bootstrap";
import { NavLink, Link, useParams } from "react-router-dom";
import { School } from '../../Services/School';
import SchoolSideMenu from "./SchoolSideMenu";
import Autocomplete from 'react-autocomplete';
import { NotificationManager } from 'react-notifications';
import config from "./../../config";
import { useHistory } from 'react-router-dom';
import { FecthData } from '../../Services/FetchData';
import FieldErrors from '../../Services/FieldErrors';
import { Admin } from '../../Services/Admin';
import ShortUserInfo from './ShortUserInfo';
import { getResourceUrl } from '../../Services/CommanFunctions';
import { getMaskedText, removeField } from '../../helpers/utils';

function SchoolDashboard() {
  const [isVisible, setIsVisible] = useState(true);
  const [student, setStudent] = useState({});
  const [selectedStudent, selectStudent] = useState()
  const [index, setIndex] = useState(0)
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
  })
  const [error, setError] = useState();
  const [fieldError, setFieldError] = useState();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [value, setValue] = useState('');
  const [validated, setValidated] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'))
  const [filter, setFilter] = useState('')
  const id = user?.school.school_id
  let history = useHistory()
  const getStudentsOfSchool = () => {
    FecthData.getData('student/get_all_student_of_school/' + id + '?page=' + 0 + '&filter=' + filter).then(
      (data) => {
        setStudent(data)
        selectStudent(data?.data[index])
      },
      (error) => {
        setError(error.toString())
        NotificationManager.error(error.toString(), '!', 2000);
      }
    )
  }
  useEffect(() => {
    getStudentsOfSchool()
  }, [id]);
  const logout = () => {
    localStorage.clear()
    history.push('/school')
  }
  const submitForm = () => {
    FecthData.postJsonData({ ...formData, school_id: user?.school.school_id }, 'student/add_student').then(
      (data) => {
        if (data?.data) {
          NotificationManager.success(data.message, 'success!', 2000)

          handleClose()
        } else {
          setFieldError(data.errors.details)

        }

      }
    )
  }
  const changeUserStatus = (userId, changedStatus) => {
    Admin.changeUserStatus({ user_id: userId, status: changedStatus }).then(res => {
      getStudentsOfSchool()
    })
  }
  return (
    <>
      <section style={{ height: '100%', width: 'auto' }}>
        <div className="dashboard-wrap">
          <SchoolSideMenu />
          <div className="middle">
            <Row>
              <Col md={12}>
                <Form.Group className="form-group mb-2">
                  <Form.Control type="text" placeholder="Search" className="search-input" />
                  <Button variant="primary" type="submit" className="search-btn">
                    <img src="images/search-icon.png" alt="" width="22" />
                  </Button>
                </Form.Group>
              </Col>
            </Row>
            <div className="card">
              <Row>
                <Col md={6} className="mt-4">
                  <h3 className="text-muted mb-0">Dashboard</h3>
                </Col>
                <Col md={6} className="mt-4">
                  <div className="filters">
                    <ul>
                      <li>
                        {/* <Link to="javascript:void(0)">Sort <img src="images/sort-icon.png" alt="" width="17" />
                        </Link> */}
                        <Form.Select style={{ cursor: 'pointer' }} onChange={e => setFilter(e.target.value)}>
                          <option selected disabled>Sort</option>
                          <option value={'ASC'}>Alphabetic A-Z</option>
                          <option value={'DESC'}>Alphabetic Z-A</option>
                        </Form.Select>
                      </li>
                      <li>
                        {/* <Link to="javascript:void(0)">Filter <img src="images/filter-icon.png" alt="" width="13" />
                        </Link> */}
                        <Form.Select style={{ cursor: 'pointer' }} onChange={e => setFilter(e.target.value)}>
                          <option selected disabled>Filter</option>
                          <option value={'Last Modified'}>Last Modified</option>
                          <option value={'Oldest'}>Oldest</option>
                          <option value={'Newest'}>Newest</option>
                        </Form.Select>
                      </li>
                      <li onClick={handleShow}>
                        <a href='javascript:void(0)' className='btn-primary'>Add <img src="images/add-icon.png" alt="" width="15" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="video-category" style={{ paddingLeft: 0, }}>
                    <ul style={{ justifyContent: 'flex-start' }}>
                      <li className="active">
                        <Link to="#/">Students</Link>
                      </li>
                      <li>
                        <Link to="/school-tutor">Tutors</Link>
                      </li>
                      <li>
                        <Link to="/school-facilitator">Facilitators</Link>
                      </li>
                      <li >
                        <Link to="/school-parent">Parents</Link>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">ID</th>
                          <th scope="col">Grade</th>
                          <th scope="col">Gender</th>
                          <th scope="col">Email</th>
                          {/* <th scope="col">Edit</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {(student && student?.data?.map((content, index) => (
                          <tr key={index}
                            onClick={() => {
                              setIndex(index)
                              selectStudent(content)
                            }}
                          >
                            <td>
                              {content.gender_avatar ? <img src={content?.gender_avatar ? getResourceUrl(content.gender_avatar.icon_image) : "default_logos/no_profile_img.png"} alt="" width="44" className="rounded me-2" /> : <img src="default_logos/no_profile_img.png" alt="" width="44" className="rounded me-2" />}
                              {/* {(content.gender_avatar == 'Female' || content.gender_avatar == 'female') && <img src="images/avatar2.png" alt="" width="44" className="rounded me-2" />} */}
                              {getMaskedText(content.first_name + ' ' + content.last_name,'name') }
                            </td>
                            <td>{content.student_code}</td>
                            <td>{content?.grade_id ? content.grade_id.title : '-'}</td>
                            <td>{content?.gender_avatar?.name}</td>
                            <td>{getMaskedText(content.email,'email')}</td>
                            {/* <td><a className="btn btn-primary btn-sm" onClick={() => history.push({ pathname: "/school/user/edit", state: { ...content, user_role: 'student', status: content?.user_id.status, name: content?.user_id.name } })}>Edit</a></td> */}
                          </tr>
                        )))}
                        {!student &&
                          <tr>
                            <td colSpan="6" className="text-center">
                              <div className="spinner-border spinner-border-lg align-center"></div>
                            </td>
                          </tr>
                        }
                        {student && !student?.data?.length &&
                          <tr>
                            <td colSpan="6" className="text-center">
                              <div className="p-2">No Student To Display</div>
                            </td>
                          </tr>
                        }


                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="right">
            <ShortUserInfo />
            {/* <div className="user-short-text">
              <div className="notification-bell">
                <img src="images/bell-icon.png" alt="" width="32" />
                <div className="noti-dot"></div>
              </div>
              <div className="user-short-profile">

                <div className="user-avatar">
                  {user?.propic && <img src={user?.propic} width={'100%'} height={'100%'} alt="" />}{!user?.propic && <img src="default_logos/school-logo.png" width={'100%'} height={'100%'} alt="" />}
                </div>
                <div className="user-short-name">
                  <h5>{user?.name}  </h5>
                  <p>Academic Year 2021-2022</p>
                </div>
                {/* <Button variant="outline-secondary" onClick={logout}>Logout</Button> */}
            {/* <Dropdown >
                  <Dropdown.Toggle drop='none' variant="">

                  </Dropdown.Toggle >
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={logout}
                    // href="#/action"
                    >Logout</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
            {/* <div className="drop-down">
                  <img src="images/drop-icon.png" alt="" width="10" />
                </div> *
              </div>
            </div> */}
            {selectedStudent ? <div className="card">
              <div className="school-side-details">
                <div className="school-logo-circle">
                  {selectedStudent.gender_avatar ? <img src={selectedStudent?.gender_avatar ? getResourceUrl(selectedStudent.gender_avatar.icon_image) : "default_logos/no_profile_img.png"} alt="" /> : <img src="default_logos/no_profile_img.png" alt="" />}
                  {/* <img src="images/avatar3.png" alt="" /> */}
                </div>
                <div className="school-more-option">
                  <Dropdown>
                    <Dropdown.Toggle>
                      <img src="images/more-icon.png" alt="" width="20" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#" onClick={() => history.push({ pathname: "/school-student-stats", state: selectedStudent })}>View Profile</Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item href="#" onClick={() => history.push({ pathname: "/school/user/edit", state: { ...selectedStudent, user_role: 'student', ...removeField(selectedStudent?.user_id,['_id','user_role']), user_sf_id: selectedStudent?.user_id._id } })}>Edit Account</Dropdown.Item>
                      {/* <Dropdown.Divider />
                       */}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="school-name">
                  <h5>{getMaskedText(selectedStudent?.first_name,'name') } {getMaskedText(selectedStudent?.last_name,'name') }</h5>
                  <h6>Student ID: {selectedStudent?.student_code}</h6>
                </div>
                <div className="teacher-contact-detail">
                  <ul>
                    <li>
                      <a href="javascript:void(0)">
                        <img src="images/teacher-info1.png" alt="" width="54" />
                      </a>
                    </li>
                    <li className='phone-li'>
                      <a href={`tel:${selectedStudent?.phone}`} itemRef='ghgf'>
                        <img src="images/teacher-info2.png" alt="" width="54" />
                      </a>
                      {selectedStudent?.phone ? <span className='show-phone'>{getMaskedText(selectedStudent?.phone,'phone')}</span> : <span className='show-phone'>Phone Not Available</span>}
                    </li>
                    <li>
                      <a href={`mailto:${selectedStudent?.email}`}>
                        <img src="images/teacher-info3.png" alt="" width="54" />
                      </a>
                    </li>
                  </ul>
                  <a href="javascript:void(0)" className={`btn btn-${selectedStudent?.user_id.status == 'Active' ? 'primary' : 'secondary'} solid btn-sm no-shadow d-block`}>Status: {selectedStudent?.user_id.status}</a>
                </div>
                <div className="about-teacher">
                  {/* <h4>About:</h4>
                  <p>
                    Lorem ipsum dolor sit, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </p> */}
                  <h4>Gender:</h4>
                  <p>{selectedStudent?.gender_avatar?.name}</p>
                  {/* <h4>Date of birth</h4>
                  <p>2 Jan 2003</p> */}
                  <h4>Email:</h4>
                  <p>{getMaskedText(selectedStudent?.email,'email')}</p>
                  <h4>Parent’s Email:</h4>
                  <p>{getMaskedText(selectedStudent?.guardian_email,'email')}</p>
                  {selectedStudent?.facilitator_email ? <><h4>Facilitator Email:</h4>
                    <p>{getMaskedText(selectedStudent?.facilitator_email,'email')}</p></> : null}
                  {selectedStudent?.subjects.map.length>0&&<><h4>Subjects Interested:</h4>
                  <div className="tutor-subject mt-2">
                    <ul>
                      {selectedStudent?.subjects.map(subject => <li>
                        {subject?.title}
                      </li>)}
                      {/* <li>
                        Algebra
                      </li>
                      <li>
                        Science
                      </li>
                      <li>
                        Physics
                      </li>
                      <li>
                        Geography
                      </li>
                      <li>
                        Calculus
                      </li> */}
                    </ul>
                  </div></>}
                </div>
                {selectedStudent?.user_id.status == 'Inactive' ? <Row>
                  <Col md="6" className="text-center mt-4">
                    <Button className="px-4 btn-pill no-shadow same-width" variant="primary" onClick={() => changeUserStatus(selectedStudent?.user_id, 'Active')}>Admit</Button>
                  </Col>
                  <Col md="6" className="text-center mt-4">
                    <Button className="px-4 btn-pill same-width" variant="secondary" onClick={() => changeUserStatus(selectedStudent?.user_id, 'Declined')}>Decline</Button>
                  </Col>
                </Row> : null}
              </div>
            </div> : null}
          </div>
        </div>
      </section>

      <Modal show={show} onHide={handleClose}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Student</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="modal-form">
              <Row>
                {/* <Form.Group className="form-group mb-3" as={Col} md="12">
                <Form.Control type="text" placeholder="Search by school name, city or zip code" />
              </Form.Group> */}
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="text" placeholder="Student First Name*" value={formData.first_name} onChange={(e) => setFormData({ ...formData, first_name: e.target.value })} />
                  <FieldErrors errors={fieldError} field="first_name" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="text" placeholder="Student Last Name*" value={formData.last_name} onChange={(e) => setFormData({ ...formData, last_name: e.target.value })} />
                  <FieldErrors errors={fieldError} field="last_name" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="text" placeholder="Student Contact Number*" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
                  <FieldErrors errors={fieldError} field="phone" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="email" placeholder="Student Email*" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
                  <FieldErrors errors={fieldError} field="email" />
                </Form.Group>
                {/* <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="text" value="Mather High School" placeholder="School Name" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="text" value="0221457" placeholder="School Code" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="text" value="5835 N LincoIn Ave" placeholder="Address" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="email" value="Chicago" placeholder="City" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="email" value="Illinois" placeholder="State" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="email" value="60659" placeholder="Zip Code" />
                </Form.Group> */}
                <Col md="12" className="text-center mt-2">
                  <Button className="px-4 btn-pill" variant="primary" onClick={submitForm}>Send Request</Button>
                </Col>
              </Row>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

    </>
  )
}

export default SchoolDashboard
